<style>
    .error {
        color: #ff4444;
    }
</style>

<fadv-box [formGroup]="formGroup">
    <fadv-grid>
        <fadv-grid-row>
            <fadv-grid-col alignment="left">
                <fadv-typography type="label-medium" weight="500">Add Education Info</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col alignment="center">
                <fadv-alternate-alert #educationAlert variant='danger'>Please ensure your education data is valid</fadv-alternate-alert>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-box p="medium">
                    <fadv-checkbox (checkedChange)="checkedAwardedBox($event)"  variant="standard" formControlName="acquiredDegree">
                        Was the diploma awarded?
                      </fadv-checkbox>
                </fadv-box>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col col="12" alignment="left">
                <fadv-input (blur)="showValidation('institutionName')" formControlName="institutionName" type="text"
                    label="Institution Name"></fadv-input>
                <span class="error" *ngIf="this.institutionNameInvalid">
                    <small *ngIf="formGroup.get('institutionName').hasError('required')">Institution Name is
                        Required</small>
                        <small *ngIf="formGroup.get('institutionName').hasError('whitespace') && !formGroup.get('institutionName').hasError('required')">Institution Name Cannot be Empty</small>

                </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col col="12" alignment="left">
                <fadv-input (blur)="showValidation('nameAttendedUnder')" formControlName="nameAttendedUnder" type="text"
                    label="Name Attended Under"></fadv-input>
                <span class="error" *ngIf="this.nameAttendedUnderInvalid">
                    <small *ngIf="formGroup.get('nameAttendedUnder').hasError('required')">Name Attended Under is Required</small>
                    <small *ngIf="formGroup.get('nameAttendedUnder').hasError('whitespace') && !formGroup.get('nameAttendedUnder').hasError('required')">Name Cannot be Empty</small>
                </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-date-picker (blur)="handleStartDate($event)" #fadvDatePickerStartDate [invalid]="startDateInvalid" [max]="today"
                    label="Start Date" variant="primary"></fadv-date-picker>
                <div>
                    <span *ngIf="this.startDateInvalid">
                        <small *ngIf="this.startDate.hasError('required')" class="text-danger">Please enter a valid start
                            date</small>
                    </span>
                </div>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-date-picker (blur)="handleEndDate($event)" #fadvDatePickerEndDate [invalid]="endDateInvalid" [max]="today"
                    label="End Date" variant="primary"></fadv-date-picker>
                <div>
                    <span *ngIf="this.endDateInvalid">
                        <small *ngIf="this.endDate.hasError('notSelected')" class="text-danger">End date is
                            required</small>
                    </span>
                </div>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="left">
                <fadv-select (blur)="showValidation('levelOfEducation');" formControlName="levelOfEducation" hoist="true"
                    scrollable="true" label="Level of Education">
                    <fadv-menu-item (click)="handleShowDegree(type.value);" #levelOfEducation *ngFor="let type of levelsOfEducation | keyvalue" value="{{type.value}}">
                        {{type.value}}</fadv-menu-item>
                </fadv-select>
                <span class="error" *ngIf="this.levelOfEducationInvalid">
                    <small *ngIf="formGroup.get('levelOfEducation').hasError('required')">Level of education is
                        Required</small>
                </span>
            </fadv-grid-col>

            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="left">
                <fadv-input (blur)="showValidation('fieldOfStudy')" formControlName="fieldOfStudy" type="text"
                    label="Field of Study"></fadv-input>
                <span class="error" *ngIf="this.fieldOfStudyInvalid">
                    <small *ngIf="formGroup.get('fieldOfStudy').hasError('required')">Field of Study is Required</small>
                    <small *ngIf="formGroup.get('fieldOfStudy').hasError('whitespace') && !formGroup.get('fieldOfStudy').hasError('required')">Field of Study Cannot be Empty</small>
                </span>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-date-picker (blur)="handleDateAwarded($event)" #fadvDatePickerAwardedDate [invalid]="dateRecievedInvalid" [max]="today" [disabled]="this.enableAwardedDate == false"
                    label="Date Diploma Recieved" variant="primary"></fadv-date-picker>
                <div>
                    <span *ngIf="this.dateRecievedInvalid">
                        <small *ngIf="this.dateRecieved.hasError('required')" class="text-danger">Please enter a valid date</small>
                    </span>
                </div>
            </fadv-grid-col>
            <fadv-grid-col *ngIf="this.showDegree == true" [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="left">
                <fadv-select  (blur)="showValidation('typeOfDegree');" formControlName="typeOfDegree" hoist="true"
                    scrollable="true" label="Type of Degree">
                    <fadv-menu-item *ngFor="let type of typesOfDegree | keyvalue" value="{{type.value}}">
                        {{type.value}}</fadv-menu-item>
                </fadv-select>
                <span class="error" *ngIf="this.levelOfEducationInvalid">
                    <small *ngIf="formGroup.get('levelOfEducation').hasError('required')">Type of Degree is
                        Required</small>
                </span>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="left">
                <fadv-input (blur)="showValidation('city')" formControlName="city" type="text" label="City">
                </fadv-input>
                <span class="error" *ngIf="this.cityInvalid">
                    <small *ngIf="formGroup.get('city').hasError('required')">City is Required</small>
                    <small *ngIf="formGroup.get('city').hasError('whitespace') && !formGroup.get('city').hasError('required')">City Cannot be Empty</small>
                </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="left">
                <fadv-select formControlName="state" label="State*" hoist="true" scrollable="true">
                    <fadv-menu-item *ngFor="let state of states" value="{{state.code}}">{{ state.name }}</fadv-menu-item>
                </fadv-select>
            </fadv-grid-col>
        </fadv-grid-row>
        <!-- <fadv-grid-row>
            <fadv-grid-col alignment="right" [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-box>
                    <fadv-button pill="true" [disabled]="loading || this.educationFormInvalid || this.disableEducationButton" size="medium"
                        variant="primary" (click)="addEducation()" type="button">Add Education Info</fadv-button>
                </fadv-box>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-box >
                    <fadv-button pill="true" [disabled]="loading" size="medium"
                        (click)="cancel()" type="button">Reset</fadv-button>
                </fadv-box>
            </fadv-grid-col>
            <fadv-grid-row>
                <fadv-grid-col [col]="{ xxl: 10, xl: 9, lg: 9, md: 8, sm: 12, xs: 12 }">
                    <fadv-box [mb]="{ sm: 'medium', xs: 'medium' }">
                        <fadv-tag *ngFor="let institution of institutions;" removable="true" size="large" pill="true"
                            (removed)="removeEducation(institution)" variant="success">
                            {{institution.levelOfEducation}} at {{ institution.institutionName }}</fadv-tag>
                    </fadv-box>
                </fadv-grid-col>
            </fadv-grid-row>
        </fadv-grid-row> -->
    </fadv-grid>
</fadv-box>